define('pages/main/settings',["jquery", "appquery", "app", "modules/setup"], function($, $$, App, Setup) {
    $$ = $$("settings");

    return {
        init : function(data) {
            $$('#expiryDate').html(App.utils.date.formatDateTime(App.global('expires_on')));

            $$('#updateForm').submit(function(e) {
                e.preventDefault();
                var update = $(this).serializeObject().load;
                var load = 'nothing';
                if(update) {
                    if(update.indexOf('layout') > -1) {
                        load = 'layout';
                    }
                    if(update.indexOf('products') > -1) {
                        if(load != 'nothing') {
                            load = null;
                        } else {
                            load = 'products';
                        }
                    }
                    if(update.indexOf('device') > -1) {
                        if(load != 'nothing') {
                            Setup.fetchDeviceInfo(load);
                        } else {
                            Setup.fetchDeviceInfo(function() {
                                Setup.checkLocationAndReload();
                            });
                        }
                    } else {
                        Setup.updateData(load);
                    }
                }
            });

            $$('#unregister').click(function(){
                Setup.unregister(true);
            });
        },
        footer : true
    };
});
